import getAccessHeader from '@paywall/utils/getAccessHeader';
import checkAccessQuery from '@paywall/graphql/checkAccess.graphql';
import errorLogger from '@paywall/utils/errorLogger';
import isServerError from '@paywall/utils/isServerError';
import { CheckAccess } from '@paywall/types/checkAccess';
import { PaywallAccessType } from '@paywall/types';

import ServiceBase from '@ekd/portal-connector/dist/Service';
import { ApiUrls } from '@root/common/types/apiUrls';

type CheckAccessArguments = {
  channelId: string;
  articleId: string;
  token: string | null;
  type: PaywallAccessType;
  ip?: string;
};

/**
 * Check if user has access to product with login-api JWT token, with Zlick JWT token or with ElisaRaamat x-signature
 */
export function createCheckAccessService({ service }: { service: ServiceBase<ApiUrls> }) {
  return {
    async checkAccess({ channelId, articleId, token, type, ip }: CheckAccessArguments) {
      const noAccess = { access: false, token: null };

      if (!token) {
        return noAccess;
      }

      const headers = token && getAccessHeader(token, type);

      const variables = { channelId: Number(channelId), articleId, issuedId: '', ip };

      try {
        const apiProvider = service.createProvider('GraphQL');
        apiProvider.selectAPI('paywall-api');

        const data = await apiProvider.request<CheckAccess['data']>({ query: checkAccessQuery, variables, context: { headers } });

        return { access: data.access, token: data.token };
      } catch (error) {
        // Handle API 500 errors
        if (isServerError(error)) {
          errorLogger({ name: 'checkAccess() - server error', message: error });
          return { access: true, token: null };
        }
        errorLogger({ name: 'checkAccess()', message: error });
        return noAccess;
      }
    },
  };
}
